import { render } from "./YourSeller.vue?vue&type=template&id=59518a6f&scoped=true"
import script from "./YourSeller.vue?vue&type=script&lang=js"
export * from "./YourSeller.vue?vue&type=script&lang=js"

import "./YourSeller.vue?vue&type=style&index=0&id=59518a6f&lang=scss&scoped=true"
import "./YourSeller.vue?vue&type=style&index=1&id=59518a6f&lang=scss"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59518a6f"]])

export default __exports__